import React, { useState,useEffect,useRef } from "react";
// import "./ElementorAccordion.css"; // optional for styles

const ElementorAccordion = ({accordionData}) => {
  const [activeIndex, setActiveIndex] = useState(null);
const contentRefs = useRef([]);


 const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Adjust height smoothly when activeIndex changes
  useEffect(() => {
    accordionData.forEach((_, index) => {
      const el = contentRefs.current[index];
      if (el) {
        if (activeIndex === index) {
          el.style.maxHeight = el.scrollHeight + "px";
        } else {
          el.style.maxHeight = "0px";
        }
      }
    });
  }, [activeIndex]);

  return (
    <div className="elementor-widget-container">
      <div className="elementor-accordion">
        {accordionData?.map((item, index) => (
          <div className="elementor-accordion-item" key={item.id}>
            <div
              id={`elementor-tab-title-2341`}
              className={`elementor-tab-title ${
                activeIndex === index ? "elementor-active" : ""
              }`}
              onClick={() => toggleAccordion(index)}
              role="button"
              tabIndex={index}
              aria-expanded={activeIndex === index}
              aria-selected={activeIndex === index}
            >
              <span
                className="elementor-accordion-icon elementor-accordion-icon-left"
                aria-hidden="true"
              >
                <span className="elementor-accordion-icon-closed">
              
                         {activeIndex!=index &&    <i className="fa fa-plus" /> }
                </span>
                <span className="elementor-accordion-icon-opened">
                    {activeIndex===index &&<i className="fa fa-minus" /> }
                  
                </span>
              </span>
              <a className="elementor-accordion-title" >{item.title}</a>
            </div>

            <div
                 ref={(el) => (contentRefs.current[index] = el)}
              id={`elementor-tab-content-${item.id}`}
              className={`elementor-tab-content elementor-clearfix ${
                activeIndex === index ? "elementor-active" : ""
              }`}
              style={{
                maxHeight: activeIndex === index ? "200px" : "0",
                overflow: "hidden",
                // display: activeIndex === index ? "block" : "none",
                transition: "max-height 0.6s ease",
              }}
            >
              <p style={{ margin: "10px 0" }}>{item.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ElementorAccordion;
